import React, { FC } from "react";
import { Text, TextProps } from "@chakra-ui/layout";

interface Props extends TextProps {
  a11y?: boolean;
}

export const Bold: FC<Props> = ({ a11y, ...props }) => {
  const tag = a11y ? "strong" : "b";

  return <Text as={tag} fontWeight="bold" color="gray.800" mb="0" {...props} />;
};
